import type { SxProps} from '@mui/material';

import { Typography } from '@mui/material';

import { FILE } from '../../chatConfig';

type TFileNameProps = {
  name: string;
  sx?: SxProps;
};

function FileName({ name, sx }: TFileNameProps) {
  return (
    <Typography
      variant="body2"
      color="text.disabled"
      sx={{
        maxWidth: `${FILE.W_MAX}px`,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        ...sx,
      }}
    >
      {name}
    </Typography>
  );
}

export default FileName;
